<template>
  <ClaimsList
    :is-mobile="$q.screen.xs"
    :leases="leases"
    :leases-loading="leasesLoading"
    :lease="selectedLease"
    :status="selectedStatus"
    :claims="claims"
    :claims-loading="claimsLoading"
    :receipts-opening="receiptsOpening"
    :images="images"
    :disable="disableClaims"
    :can-show-ev-claim="canShowEvClaim"
    @select:lease="selectLease"
    @select:status="selectStatus"
    @open:receipts="openReceipts"
    @start:claim="startClaim"
    @start:evclaim="startEvClaim"
  />
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { getFileApi } from '../../api/files';
import { openUrl, getAsset } from 'ecx.saigon.ui.common';

export default {
  name: 'ClaimsWidget',
  data() {
    return {
      receiptsOpening: {},
      images: {}
    };
  },
  computed: {
    ...mapState({
      hasLeases: (state) => state.lease.hasLeases,
      leases: (state) => state.lease.leases,
      leasesLoading: (state) => state.lease.leasesLoading,
      selectedLease: (state) => state.lease.selectedLease,
      selectedStatus: (state) => state.claim.selectedStatus,
      claims: (state) => state.claim.claims,
      claimsLoading: (state) => state.claim.claimsLoading
    }),
    ...mapGetters('lease', ['leaseIds', 'activeLeases', 'evVehicleLeases']),
    disableClaims() {
      return !Boolean(this.activeLeases.length);
    },
    canShowEvClaim() {
      return Boolean(this.evVehicleLeases.length);
    }
  },
  watch: {
    leasesLoading() {
      if (!this.leasesLoading) {
        this.hydrate();
      }
    }
  },
  methods: {
    ...mapActions('claim', ['getClaims']),
    ...mapMutations('claim', ['setSelectedStatus']),
    ...mapMutations('lease', ['setSelectedLease']),
    selectLease(lease) {
      this.setSelectedLease(lease);
      this.getClaims();
    },
    selectStatus(status) {
      this.setSelectedStatus(status);
      this.getClaims();
    },
    async openReceipts({ fileIds = [], claimId }) {
      if (!fileIds.length) {
        return;
      }

      try {
        this.receiptsOpening = { ...this.receiptsOpening, [claimId]: true };
        const files = await Promise.all(fileIds.map(getFileApi));
        // It is possible that some browsers like chrome will block us from opening multiple tabs.
        // Unfortunately that is not something we can overcome with code.
        files.forEach((file) => openUrl(file.signedUrl));
        this.receiptsOpening = { ...this.receiptsOpening, [claimId]: false };
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        this.receiptsOpening = { ...this.receiptsOpening, [claimId]: false };
      }
    },
    startClaim() {
      this.$router.push({
        name: this.$RouteNames.claimsNew
      });
    },
    startEvClaim() {
      this.$router.push({
        name: this.$RouteNames.claimsEvNew
      });
    },
    async hydrate() {
      if (!this.hasLeases) {
        return this.$router.push({
          name: this.$RouteNames.dashboard
        });
      }

      // Default to selecting the first lease id if none were previously selected
      if (!this.selectedLease.id) {
        this.setSelectedLease(this.leases[0]);
      }

      await this.getClaims();
    }
  },
  async mounted() {
    this.images = {
      ...this.images,
      startClaim: await getAsset(this.$Constants.CLAIM_START_IMG_PATH)
    };

    if (this.hasLeases) {
      await this.hydrate();
    }
  },
  components: {
    ClaimsList: () => import('../../components/page/claims-list')
  }
};
</script>
